import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { sxModal, sxModalSubtitle, sxModalTitle } from './sxProps';
import './styles.css'
import Calendar from './Calendar';
import { CalendarModalProps } from '../../../interfaces/props/SaudeOnline/LinhaTempo/CalendarModalProps';
import { Typography } from '@mui/material';
import moment from 'moment';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function CalendarModal(props: CalendarModalProps) {

    const accessibility = useAccessibility();

    const handleCloseModal = () => {
        props.handleCloseModal();
    }

    const handleDate = (date: Date) => {
        if (date !== null) {
            props.handlePickDate(moment(date.toISOString()).format('DD/MM/YYYY'));
        }
    }

    const fromDateString = (dateString: string): Date => {
        if (dateString) {
            return new Date(moment(dateString, 'DD/MM/YYYY').toISOString());
        } else {
            return new Date();
        } 
    }

    return (
        <div>
        <Modal
            open={props.open}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={sxModal} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
                <div className="confirmation-feedback-modal-header">
                    <div style={{marginRight: 'auto'}} />
                    <button aria-label="fechar" className='confirmation-modal-header-close' onClick={handleCloseModal}><FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faTimes} /></button>
                </div>
                <div className="calendar-holder">
                    <Typography style={accessibility.textStyleAccessibility} sx={{...sxModalSubtitle, marginBottom: '15px'}}>Selecione uma data no calendário</Typography>
                    <div className="calendar-selection">
                        <Calendar 
                            handleDate={handleDate} 
                            selectedDate={fromDateString(props.selectedDate)}
                            minDate={props.minDate}
                            maxDate={props.maxDate}
                        />
                    </div>
                </div>
            </Box>
        </Modal>
        </div>
      );
}

export default CalendarModal;